import { createContext, ReactNode, useState } from "react";

type OrganizationState = {
  eligibilityGroups: string[];
  isEligibilityGroupsLoading: boolean;
  organizationDisplayNames: Record<string, string>;
  organizations: string[];
  setEligibilityGroups: (eligibilityGroups: string[]) => void;
  setIsEligibilityGroupsLoading: (isLoading: boolean) => void;
  setOrganizationDisplayNames: (names: Record<string, string>) => void;
  setOrganizations: (organizations: string[]) => void;
  setSelectedEligibilityGroup: (selectedEligibilityGroup: string | null) => void;
  selectedEligibilityGroup: string | null;
};

const initialOrganizationState: OrganizationState = {
  eligibilityGroups: [],
  isEligibilityGroupsLoading: false,
  organizationDisplayNames: {},
  organizations: [],
  selectedEligibilityGroup: null,
  setEligibilityGroups: () => {},
  setIsEligibilityGroupsLoading: () => {},
  setOrganizationDisplayNames: () => {},
  setOrganizations: () => {},
  setSelectedEligibilityGroup: () => {}
};

export const OrganizationContext = createContext<OrganizationState | undefined>(undefined);

export const OrganizationProvider = ({ children }: { children: ReactNode }) => {
  const [state, setState] =
    useState({
      eligibilityGroups: [] as string[],
      isEligibilityGroupsLoading: false,
      organizationDisplayNames: {} as Record<string, string>,
      organizations: [] as string[],
      selectedEligibilityGroup: null as string | null
    });

  const setIsEligibilityGroupsLoading = (isLoading: boolean) => {
    setState((prevState) => ({
      ...prevState,
      isEligibilityGroupsLoading: isLoading
    }));
  };

  const setSelectedEligibilityGroup = (selectedEligibilityGroup: string | null) => {
    setState((prevState) => ({
      ...prevState,
      selectedEligibilityGroup
    }));
  };

  const updateEligibilityGroups = (eligibilityGroups: string[]) => {
    setState((prevState) => ({
      ...prevState,
      eligibilityGroups
    }));
  };

  const updateOrganizations = (organizations: string[]) => {
    setState((prevState) => ({
      ...prevState,
      organizations
    }));
  };

  const updateOrganizationDisplayNames = (organizationDisplayNames: Record<string, string>) => {
    setState((prevState) => ({
      ...prevState,
      organizationDisplayNames
    }));
  };

  return (
    <OrganizationContext.Provider
      value={{
        ...state,
        setEligibilityGroups: updateEligibilityGroups,
        setIsEligibilityGroupsLoading,
        setOrganizations: updateOrganizations,
        setOrganizationDisplayNames: updateOrganizationDisplayNames,
        setSelectedEligibilityGroup
      }}
    >
      {children}
    </OrganizationContext.Provider>
  );
};
